import { CaseScreenHeaderDetailsColumnNew } from 'src/components/organismsLegacy/CaseScreenHeader/CaseScreenHeader.styles';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const HeaderSectionCount = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.action.primary.default};
  margin: 0;
`;

export const HeaderSubsectionTitle = styled.h3`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const CaseLeadDropdownContainer = styled.div`
  margin: 0 0 10px 0;
`;

export const HeaderSectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const CaseScreenHeaderDetailsColumnNewTeamPanel = styled(
  CaseScreenHeaderDetailsColumnNew,
)`
  padding: 0;
`;

export const InnerContainer = styled.div`
  padding: 0 20px;
`;
